<template>
    <div class="form delivery-address-form">
        <div class="address-details">
            <div class="address-row">
                <span class="address-label">{{ translations.deliveryAddress.street }}</span>
                <span class="address-value">{{ deliveryAddress.street }}</span>
            </div>

            <div class="address-row" v-if="deliveryAddress.addressDetails">
                <span class="address-label">{{ translations.deliveryAddress.addressDetails }}</span>
                <span class="address-value">{{ deliveryAddress.addressDetails }}</span>
            </div>

            <div class="address-row">
                <span class="address-label">{{ translations.deliveryAddress.postalCodeAndCity }}</span>
                <span class="address-value">{{ deliveryAddress.postalCode }} {{ deliveryAddress.city }}</span>
            </div>

            <div class="address-row">
                <span class="address-label">{{ translations.deliveryAddress.country }}</span>
                <span class="address-value">{{ translations.enums.Country[Country[deliveryAddress.country]] }}</span>
            </div>
        </div>

        <VButton class="ok-btn primary rounded" @click="props.hide">{{ trans.general.ok }}</VButton>
    </div>
</template>

<script setup lang="ts">
    import type { IDeliveryAddress } from "@/data/model/Customer";
    import { Country } from "@/data/model/Enums";
    import { trans } from "@/operator/localization/Trans";
    import { translations } from "@/shared/localization/translations";
    import { onMounted } from "vue";

    import VButton from "@/components/elements/VButton.vue";

    // define props
    const props = defineProps<{
        hide?: () => void;
        deliveryAddress: IDeliveryAddress;
    }>();

    onMounted(() => {});
</script>

<style scoped lang="scss">
    .delivery-address-form {
        text-align: start;

        > .address-name {
            font-weight: 600;
            margin-bottom: 16px;
        }

        > .address-details {
            display: flex;
            flex-direction: column;
            gap: 10px;
            border-radius: 12px;
            margin-bottom: 20px;

            .address-row {
                display: flex;
                align-items: baseline;
                gap: 8px;

                .address-label {
                    flex-shrink: 0;
                    width: 150px;
                    font-size: 12px;
                    font-weight: 600;
                    text-transform: uppercase;
                    color: #aaa;
                }

                .address-value {
                    font-size: 15px;
                    font-weight: 400;
                    color: #484848;
                    line-height: 1.4;
                }
            }
        }

        > .ok-btn {
            height: 46px;
            font-size: 16px;
            font-weight: 300;
            width: 100%;
            margin-top: 12px;
            border-radius: 23px !important;
        }
    }
</style>
